// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"FormSection_buttonsContainer__2WqU8","prevBtn":"FormSection_prevBtn__Nhr-4","formError":"FormSection_formError__2xK0m"};